import { DataFeedsModals, DataFeedsModalStateType, useModalContext } from 'utils/contexts/modal';

import { ConfirmDeleteModal } from './ConfirmDeleteModal';
import { DataFeedsModal } from './DataFeedsModal';
import { EditAliasModal } from './EditAliasModal';

export const Modals = () => {
  const { modalState } = useModalContext<DataFeedsModalStateType>();

  switch (modalState?.modal) {
    case DataFeedsModals.ConfirmDelete:
      return <ConfirmDeleteModal />;
    case DataFeedsModals.CreateFeed:
    case DataFeedsModals.EditFeed:
      return <DataFeedsModal />;
    case DataFeedsModals.EditAlias:
      return <EditAliasModal />;
    default:
      return null;
  }
};
